import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const BroadcastConfirmationModal = ({ show, count, cancel, confirm, isBroadcasting, error }) => (
  <Modal isOpen={show} toggle={isBroadcasting ? undefined : cancel} backdrop={isBroadcasting ? "static" : true} keyboard={!isBroadcasting}>
    <ModalHeader toggle={isBroadcasting ? undefined : cancel}>Konfirmasi Broadcast</ModalHeader>
    <ModalBody>
      <p>Broadcast ke <strong>{count}</strong> pemenang non-diskualifikasi? Aksi ini tidak dapat dibatalkan.</p>
      {error && <div className="broadcast-preview-alert is-blocker" role="alert">{error}</div>}
    </ModalBody>
    <ModalFooter>
      <button type="button" className="button-batal" onClick={cancel} disabled={isBroadcasting}>Batal</button>
      <button type="button" className="button-simpan" onClick={confirm} disabled={isBroadcasting}>
        {isBroadcasting && <span className="spinner-border spinner-border-sm mr-2" aria-hidden="true" />}
        {isBroadcasting ? "Sedang broadcast..." : "Broadcast Sekarang"}
      </button>
    </ModalFooter>
  </Modal>
);

export default BroadcastConfirmationModal;

